var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7806 8.53024L11.0306 15.2802C10.9257 15.3852 10.792 15.4568 10.6465 15.4858C10.5009 15.5147 10.35 15.4999 10.2129 15.4431C10.0758 15.3863 9.95861 15.29 9.87621 15.1666C9.79381 15.0432 9.74988 14.898 9.75 14.7496V8.74961H0.75C0.551088 8.74961 0.360322 8.6706 0.21967 8.52995C0.0790178 8.38929 0 8.19853 0 7.99961C0 7.8007 0.0790178 7.60994 0.21967 7.46928C0.360322 7.32863 0.551088 7.24961 0.75 7.24961H9.75V1.24961C9.74988 1.10119 9.79381 0.956073 9.87621 0.832627C9.95861 0.709182 10.0758 0.612962 10.2129 0.556147C10.35 0.499333 10.5009 0.484479 10.6465 0.513467C10.792 0.542455 10.9257 0.613981 11.0306 0.718989L17.7806 7.46899C17.8504 7.53864 17.9057 7.62136 17.9434 7.71241C17.9812 7.80346 18.0006 7.90105 18.0006 7.99961C18.0006 8.09818 17.9812 8.19577 17.9434 8.28682C17.9057 8.37787 17.8504 8.46058 17.7806 8.53024Z",
    fill: "#5604F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.38fcef71edabd0e7dc4a9fb862ca5ac5.svg";
export { ForwardRef as ReactComponent };